<ph-search-select [items]="items"
                  [toggles]="toggles"
                  [value]="selectedKey"
                  [placeholder]="placeholder"
                  [hasError]="hasError"
                  [disabled]="disabled"
                  search-placeholder="Search categories…"
                  empty-label="No matching categories"
                  (ph-change)="onPick($event.detail)"
                  (ph-toggle)="onToggle($event.detail)"></ph-search-select>
